import { createColumnHelper, getCoreRowModel, getPaginationRowModel, useReactTable } from '@tanstack/react-table'
import React, { useState } from 'react'

import { type EmployeeWithPaySchedules } from './types'
import TanstackTable from '../reusable/table/TanstackTable'

interface UnassignedEmployeesTableProps {
  data: EmployeeWithPaySchedules[]
  isLoading: boolean
}

// Column definitions for the employee table
const columnHelper = createColumnHelper<EmployeeWithPaySchedules>()
const columns = [
  columnHelper.accessor(row => `${row.first_name} ${row.last_name}`, {
    id: 'name',
    header: 'Name',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.work_email || row.personal_email || '', {
    id: 'email',
    header: 'Email',
    cell: info => info.getValue(),
  }),
]

export const UnassignedEmployeesTable: React.FC<UnassignedEmployeesTableProps> = ({
  data,
  isLoading
}) => {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  // Table setup
  const table = useReactTable({
    data: data || [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    state: { pagination },
    onPaginationChange: setPagination,
    manualPagination: false,
  })

  return (
    <div className='mb-6'>
      {isLoading
        ? (
          <div className='flex justify-center items-center h-32'>
            <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-thatch-purple' />
          </div>
          )
        : data.length === 0
          ? (
            <div className='text-gray-500 text-center py-4'>All employees have been assigned to pay schedules</div>
            )
          : (
            <TanstackTable
              table={table}
              tableClasses='overflow-hidden'
              tableMessageHeightClass='h-16'
              paginationLabelSingular='employee'
            />
            )}
    </div>
  )
}
